import DateRangeInput from "src/components/common/DateRangeInput";

interface PDA1030_R01SearchProps {
  startDate: string;
  endDate: string;
  isLoading: boolean;
  onStartDateChange: (date: string) => void;
  onEndDateChange: (date: string) => void;
  onSearch: () => void;
}

const PDA1030_R01Search = ({
  startDate,
  endDate,
  isLoading,
  onStartDateChange,
  onEndDateChange,
  onSearch,
}: PDA1030_R01SearchProps) => {
  return (
    <div className="w-full bg-white p-4 pb-1 border-b border-gray-200">
      <div className="space-y-3">
        <DateRangeInput
          startDate={startDate}
          endDate={endDate}
          onStartDateChange={onStartDateChange}
          onEndDateChange={onEndDateChange}
          label="매출일자"
          labelWidth="w-20"
        />

        <button
          type="button"
          onClick={onSearch}
          disabled={isLoading}
          className="w-full bg-blue-500 text-white px-4 py-2 rounded text-lg font-medium hover:bg-blue-600 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-400 disabled:cursor-default"
        >
          조회
        </button>
      </div>
    </div>
  );
};

export default PDA1030_R01Search;
